import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  CardContent,
  Grid,
  Typography,
  TextField,
  Button,
  MenuItem,
  Autocomplete,
} from "@mui/material";
import { Card } from "react-bootstrap";

const OrderDetails = () => {
  const [returnReason, setReturnReason] = useState("");
  const [qty, setQty] = useState(0);
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const location = useLocation();
  const { apiResponse } = location.state;
  const formattedCreatedAt = new Date(apiResponse.createdAt).toLocaleString();
  const navigate = useNavigate();

  useEffect(() => {
    const updatedTotal = apiResponse.products.reduce(
      (sum, item) => sum + item.price * (qty !== 0 ? qty : item.quantity),
      0
    );
    setTotal(updatedTotal);
  }, [apiResponse.products, qty]);

  const [total, setTotal] = useState(0);

  const handleReturn = () => {
    const formData = new FormData();
    formData.append("order_id", apiResponse.order_id);
    formData.append(
      "quantity",
      qty !== 0 ? qty : apiResponse.products[0].quantity
    );
    formData.append("reason", returnReason);
    formData.append("message", message);
    formData.append("image", file);

    axios
      .post("http://api.meddaily.in/return_order_deliver", formData)
      .then((response) => {
        alert("Return was successfully");
        navigate("/orderlist");
        console.log("response", response);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleFileUpload = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <Sidebar />
        </Grid>
        <Grid item xs={12} sm={9}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Navbar />
            </Grid>
            <Grid item xs={11}>
              <Typography
                variant="h4"
                gutterBottom
                align="center"
                sx={{ marginTop: "15px" }}
              >
                Return Details
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Order ID: {apiResponse.order_id}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Created At: {formattedCreatedAt}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Distributor Name: {apiResponse.distributor_name}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Retailer Name: {apiResponse.retailer_name}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  {apiResponse.products &&
                    apiResponse.products.map((item, ind) => {
                      return (
                        <div key={ind} style={{ display: "flex", gap: "40px" }}>
                          <span>Name: {item.name}</span>
                          <span>Batch No: {item.batch_no}</span>
                          <span>Exp Date: {item.exp_date}</span>
                          <span>Price: {item.price}</span>
                          <span>Quantity: {item.quantity}</span>
                          <TextField
                            label="Return Qty"
                            id="qty"
                            name="qty"
                            type="number"
                            value={qty !== 0 ? qty : item.quantity}
                            onChange={(e) => setQty(e.target.value)}
                          />
                        </div>
                      );
                    })}
                  <h3>Estimated Return Value</h3>
                  <div
                    style={{ display: "flex", flexDirection: "row-reverse" }}
                  >
                    <span>Item total: Rs.{total}</span>
                  </div>
                  <div
                    style={{ display: "flex", flexDirection: "row-reverse" }}
                  >
                    <span>Delivery Fee: Rs.-{apiResponse.delivery_fee}</span>
                  </div>
                  <hr />
                  <div
                    style={{ display: "flex", flexDirection: "row-reverse" }}
                  >
                    <span>
                      Order Total: Rs.{total - apiResponse.delivery_fee}
                    </span>
                  </div>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  {/* <TextField
                    label="Return Reason"
                    id="reason"
                    name="reason"
                    value={returnReason}
                    onChange={(e) => setReturnReason(e.target.value)}
                    fullWidth
                    select
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          style: {
                            top: "100px",
                            maxHeight: 200,
                            width: 250,
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem value="expired">Expired Product</MenuItem>
                    <MenuItem value="mismatch">Product Mismatch</MenuItem>
                    <MenuItem value="other">Other</MenuItem>
                  </TextField> */}

                  <Autocomplete
                    id="reason"
                    name="reason"
                    value={returnReason}
                    onChange={(e, newValue) => setReturnReason(newValue)}
                    options={["expired", "mismatch", "other"]}
                    renderInput={(params) => (
                      <TextField {...params} label="Return Reason" fullWidth />
                    )}
                    renderOption={(props, option) => (
                      <MenuItem {...props} key={option} value={option}>
                        {option}
                      </MenuItem>
                    )}
                  />

                  <TextField
                    sx={{ marginTop: "20px" }}
                    label="Message"
                    id="text-area"
                    name="text-area"
                    multiline
                    rows={10}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    fullWidth
                  />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "10px",
                    }}
                  >
                    {/* <button className="continue1">
                      <input type="file" name="" id="" />
                    </button>
                    <span style={{ marginLeft: "10px" }}>
                      Select an image from file to initiate return
                    </span> */}
                    <Grid item>
                      <input
                        accept=".jpg,.png,.jpeg"
                        id="file-input"
                        type="file"
                        style={{ display: "none" }}
                        onChange={handleFileUpload}
                      />
                      <label htmlFor="file-input">
                        <Button variant="outline-primary" component="span" className="continue1" >
                          Upload
                        </Button>
                      </label>
                    </Grid>
                    <Grid item>
                      <Typography style={{ marginLeft: "10px" }}>
                        Select an image from file to initiate return
                      </Typography>
                    </Grid>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "10px",
              marginTop: "10px",
            }}
          >
            <button className="continue1" onClick={handleReturn}>
              Return
            </button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default OrderDetails;
